import { render, staticRenderFns } from "./ChartConfiguration.vue?vue&type=template&id=05cb3e48&"
import script from "./ChartConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ChartConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports